import React, { useState } from 'react';
import { CalendarInputCommonProps } from './types';
import { DateInput } from './DateInput';
import { InputProps } from '../../input';
import { isCursorItemComplete } from './utils';
import { DatePickerIcon } from '../DatePickerIcon';
import { Stack } from '../../stack';
import { getDatePickerInputStyleBySize } from '../styles';

export interface DateSingleInputProps extends CalendarInputCommonProps, Pick<InputProps, 'width' | 'size' | 'flex'> {
  className?: string;
  format?: string;
  disabled?: boolean;
  error?: boolean;
  readOnly?: boolean;
  /**
   * The target properties to write when the user manually types the date.
   */
  writeTarget?: 'from' | 'to' | 'all';
  placeholder?: string;
  onFocus?: () => void;
  onClick?: () => void;
  showRemoveButton?: boolean;
  onRemove?: () => void;
}

export const DateSingleInput: React.FC<DateSingleInputProps> = React.forwardRef(
  ({ showRemoveButton, onRemove, flex, ...props }: DateSingleInputProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    const [isHovering, setIsHovering] = useState(false);
    const { cursor } = props;
    const inputStyle = getDatePickerInputStyleBySize(props.size);
    return (
      <Stack
        direction='column'
        flex={flex}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        ref={ref}
      >
        <DateInput
          {...props}
          style={inputStyle}
          rightIcon={
            <DatePickerIcon
              showRemoveIcon={showRemoveButton && isHovering && isCursorItemComplete(cursor?.item)}
              onClick={onRemove}
            />
          }
        />
      </Stack>
    );
  },
);
